module.exports = __webpack_public_path__ + "01_glasses_red.30c392eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/01_glasses_red.png
// module id = DXrQ
// module chunks = 0